import { motion } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';
import { DownloadButtonSimple } from './DownloadButton';
import { AnimatedTitle } from '@/components/common/AnimatedTitle';

export default function Cta() {
  const { t } = useLanguage();

  return (
    <section data-scroll-section className="relative pt-32 pb-0 px-6 overflow-hidden theme-bg">
      {/* Background Grid */}
      <div
        className="absolute inset-0 pointer-events-none opacity-20"
        style={{
          backgroundImage: `
            linear-gradient(to right, rgba(0,0,0,0.06) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(0,0,0,0.06) 1px, transparent 1px)
          `,
          backgroundSize: '40px 40px',
          maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1) 20%, rgba(0,0,0,0) 80%)',
          WebkitMaskImage: 'linear-gradient(to bottom, rgba(0,0,0,1) 20%, rgba(0,0,0,0) 80%)'
        }}
      />

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="flex flex-col items-center text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="mb-8 relative z-20"
          >
            <AnimatedTitle
              text={t('ctaNew.downloadTitle')}
              className="text-3xl md:text-5xl lg:text-6xl font-light mb-6 tracking-tight leading-[1.1] pb-2"
              gradientFrom="var(--foreground)"
              gradientTo="var(--nt-primary)"
            />
            <p className="text-lg md:text-xl max-w-2xl mx-auto text-[color:var(--foreground-muted)]">
              {t('ctaNew.downloadSubtitle')}
            </p>
          </motion.div>

          {/* Download Button */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
            className="mb-12 relative z-20"
          >
            <DownloadButtonSimple className="h-14 px-8 text-base shadow-2xl shadow-purple-500/20" />
          </motion.div>

          {/* Laptop Image and Effects */}
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "0px" }}
            transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
            className="relative w-full max-w-3xl opacity-25 pointer-events-none select-none"
          >
            {/* Glow effect - removed for starker enterprise look */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 bg-white/5 blur-[80px] rounded-full -z-10" />

            <img
              src="/cta-laptop.png"
              alt="Paladino Builder Preview"
              className="w-full h-auto relative z-10 [mask-image:linear-gradient(to_bottom,transparent_0%,black_40%,transparent_100%)]"
            />

            {/* Fade out bottom gradient */}
            <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-[color:var(--background)] to-transparent z-20" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
